import {Pipe, PipeTransform} from "@angular/core";
import {DateTimeUtil} from "../../utils/date-time-util";

/**
 * Converts the number of seconds into a formatted hh:mm:ss string
 */
@Pipe({
    name: "seconds"
})
export class SecondsPipe implements PipeTransform {

    transform(value: any, args?: string): any {
        return DateTimeUtil.formatTimeForSeconds(value);
    }

}
